const MINERAL_SPRITES = ['gold_small', 'gold_medium', 'gold_large', 'rock', 'mystery_box', 'brand_ore'] as const;
const images = new Map<string, HTMLImageElement>();
const decoded = new WeakSet<HTMLImageElement>();
const loading = new Map<string, Promise<void>>();
let assetVersion = 0;

export function gameAssetNames(dateKey: string): string[] {
  return [
    'bg_surface',
    `bg_underground_${dateKey}`,
    `treasure_${dateKey}`,
    'miner_idle',
    'miner_pull',
    'claw_open',
    'claw_closed',
    ...MINERAL_SPRITES,
  ];
}

function loadSprite(name: string): { image: HTMLImageElement; ready: Promise<void> } {
  const existing = images.get(name);
  if (existing) return { image: existing, ready: loading.get(name) ?? Promise.resolve() };

  const image = new Image();
  image.decoding = 'async';
  let settled = false;
  let triedPng = false;
  let resolveReady!: () => void;
  const ready = new Promise<void>(resolve => { resolveReady = resolve; });
  const finish = () => {
    if (settled) return;
    settled = true;
    decoded.add(image);
    assetVersion += 1;
    resolveReady();
  };
  image.onload = () => {
    void image.decode().catch(() => {}).then(finish);
  };
  image.onerror = () => {
    if (!triedPng && image.src.endsWith('.webp')) {
      triedPng = true;
      image.src = `/assets/${name}.png`;
      return;
    }
    // A missing optional visual must not keep the timed game on a loader.
    resolveReady();
  };
  image.src = `/assets/${name}.webp`;
  images.set(name, image);
  loading.set(name, ready);
  return { image, ready };
}

export function sprite(name: string): HTMLImageElement {
  return loadSprite(name).image;
}

export function isSpriteDecoded(image: HTMLImageElement): boolean {
  return decoded.has(image);
}

export function currentAssetVersion(): number {
  return assetVersion;
}

export async function preloadGameAssets(dateKey: string): Promise<void> {
  await Promise.all(gameAssetNames(dateKey).map(name => loadSprite(name).ready));
}
